<template>
  <div class="image-editor-w">
    <div class="image-preview">
      <div
        class="image"
        v-for="(image, imageIndex) in images"
        :key="imageIndex"
        :style="{ backgroundImage: 'url(' + image + ')' }"
      >
        <i
          class="material-icons delete-image-button"
          @click.stop="deleteImage(imageIndex)"
        >delete_forever</i>
      </div>
      <div class="image-upload-wrapper" v-show="!uploading">
        <label for="image-input" class="image-uploader">
          <img
            src="../assets/baseline-cloud_upload-24px.svg"
            alt="upload icon"
            width="36px"
            height="36px"
          >
        </label>
          <input
          type="file"
          name="upload-image"
          id="image-input"
          accept="image/png, image/jpeg"
          @change="handleImageChange"
          style="visibility:hidden;height:0;width:0;overflow:hidden"
        />
      </div>
      <div class="loading" v-show="uploading">
        <fulfilling-square-spinner :animation-duration="4000" :size="48" color="#ff1d5e"/>
      </div>
    </div>
  </div>
</template>

<script>
import { FulfillingSquareSpinner } from 'epic-spinners'
import ResizeImage from 'image-resize'

export default {
  name: 'ItemImageInput',
  components: { FulfillingSquareSpinner },
  props: {
    images: Array
  },
  model: {
    prop: 'images',
    event: 'upload-done'
  },
  data () {
    return {
      uploading: false
    }
  },
  methods: {
    handleImageChange: async function () {
      this.uploading = true
      let imageList = JSON.parse(JSON.stringify(this.images))

      // generate the base 64 format image
      console.log('Input changed')
      var input = document.getElementById('image-input')
      let file = input.files[0]
      if (file.size / 1024 / 1024 > 10) {
        this.$message.error('Image too large, must less than 10MB')
        this.$emit('upload-done', imageList)
        this.uploading = false
        input.value = null
        return
      }
      if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
        this.$message.error('Invalid image format!')
        this.$emit('upload-done', imageList)
        this.uploading = false
        input.value = null
        return
      }
      let inputType = file.type.slice(6)
      console.log(`${inputType} upload detected!`)
      let resizeImage = new ResizeImage({
        format: inputType === 'png' ? 'png' : 'jpg',
        outputType: 'base64',
        quality: 0.8
      })
      let base64String = await resizeImage.play(
        document.getElementById('image-input')
      )

      // upload image
      let uploadResult = await this.$store.dispatch(
        'uploadImage',
        base64String
      )
      if (uploadResult.success) {
        imageList.push(uploadResult.url)
      } else {
        this.$message.error(uploadResult.error)
      }
      this.$emit('upload-done', imageList)
      this.uploading = false
      input.value = null
    },
    deleteImage: function (imageIndex) {
      let newImageList = JSON.parse(JSON.stringify(this.images))
      newImageList.splice(imageIndex, 1)
      this.$emit('upload-done', newImageList)
    }
  }
}
</script>

<style scoped>
.image {
  display: inline-block;
  border: 1px solid #ebebeb;
  margin: 5px;
  width: 100px;
  height: 100px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

#fileInput {
  display: none;
}

.image-uploader {
  display: inline-block;
  border: 3px dashed #ebebeb;
  margin: 5px;
  width: 100px;
  height: 100px;
  text-align: center;
  box-sizing: border-box;
  padding: 32px 0;
}

.image-preview {
  display: flex;
  flex-wrap: wrap;
}

.loading {
  border: 3px dashed #ebebeb;
  margin: 5px;
  width: 100px;
  height: 100px;
  padding: 26px;
  box-sizing: border-box;
}

.delete-image-button {
  cursor: pointer;
  position: absolute;
  font-size: 24px;
  right: 8px;
  top: 8px;
  color: salmon;
  z-index: 1;
}
</style>
